import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { LoginService } from '../pages/login/services/login.service';
import { isInternalRedirectPath } from '../utils/redirect-url.util';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private loginService: LoginService,
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!this.loginService.hasToken()) {
      const redirectUrl = isInternalRedirectPath(state.url) ? state.url : undefined;

      this.router.navigate(['/login'], {
        ...(redirectUrl ? { queryParams: { redirectUrl } } : {}),
        replaceUrl: true,
      });
      return false;
    }
    return true;
  }
}
